/**
 * 到店提醒
 */
import { ARRIVEREMIND } from '../types';

export default {
    name: `${ARRIVEREMIND}`,
    path: '/arriveRemind',
    component: () => import(/* webpackChunkName: 'arriveRemind' */ '@/views/arriveRemind/'),
    redirect: { name: `${ARRIVEREMIND}Index` },
    meta: {
        title: '到店提醒',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${ARRIVEREMIND}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'arriveRemind' */ '@/views/arriveRemind/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${ARRIVEREMIND}Detail`,
            path: 'detail/:id/:record',
            component: () => import(/* webpackChunkName: 'arriveRemind' */ '@/views/arriveRemind/detail/Detail.vue'),
        },
    ],
};
